import React from "react";
import { useAuth } from "../auth";

const UserAccountDisplay: React.FC = () => {
  const { user, signOut } = useAuth();

  return (
    <div className="user-account-display">
      <div className="user-info">
        {user?.picture && <img src={user.picture} alt={user?.name || user?.email || "User"} className="user-avatar" />}
        <div className="user-details">
          {user?.name && <div className="user-name">{user.name}</div>}
          {user?.email && <div className="user-email">{user.email}</div>}
        </div>
      </div>
      <button onClick={signOut} className="signout-btn">
        Sign out
      </button>

      <style>{`
        .user-account-display {
          width: 100%;
          margin-left: 4px;
          border: 4px solid #000;
          background: #fff;
          box-shadow: 6px 6px 0 #000;
          padding: 10px 14px;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
        }
        
        .user-info {
          display: flex;
          align-items: center;
          gap: 10px;
          min-width: 0;
          overflow: hidden;
        }
        
        .user-avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: 2px solid #000;
          box-shadow: 2px 2px 0 #000;
          flex-shrink: 0;
        }
        
        .user-details {
          flex: 1;
          min-width: 0;
          overflow: hidden;
        }
        
        .user-name {
          font-weight: 800;
          font-size: 0.9rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .user-email {
          font-size: 0.9rem;
          color: #444;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .signout-btn {
          border: 3px solid #000;
          box-shadow: 4px 4px 0 #000;
          background: #fff;
          padding: 4px 8px;
          font-weight: 800;
          font-size: 0.85rem;
          text-transform: uppercase;
          cursor: pointer;
          transition: transform 80ms ease-out, box-shadow 80ms ease-out;
          flex-shrink: 0;
          margin-left: 8px;
          white-space: nowrap;
        }
        
        .signout-btn:hover {
          transform: translate(-2px, -2px);
          box-shadow: 6px 6px 0 #000;
        }
        
        @media (max-width: 760px) {
          .user-account-display {
            margin-bottom: 12px;
            padding: 8px 10px;
            width: 100%;
            margin-left: 4px;
          }
          
          .user-avatar {
            width: 32px;
            height: 32px;
          }
          
          .signout-btn {
            padding: 3px 6px;
            font-size: 0.8rem;
          }
        }
        }
      `}</style>
    </div>
  );
};

export default UserAccountDisplay;
